import logoIcon from 'assets/img/logo.svg'
import * as React from 'react'
import './style.scss'

interface IProps {
  size: string
}

export const Logo: React.FC<IProps> = ({ size }: IProps) => (
  <div style={{ width: size, height: size }} className="logo-link">
    <img className="logo-img" src={logoIcon} />
  </div>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.tsx